import { AbstractOption } from './abstract-option';
import { Logger } from './utilities/logger';
/**
 * Essential consent option, meaning it cannot be enabled and/or disabled by the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class EssentialOption extends AbstractOption {
    constructor(api, group, data) {
        super(api, group, data);
        Logger.debug('essential-option', `Starting to construct "${this.uid}".`);
        this.group = group;
        Logger.debug('essential-option', `Finished constructing "${this.uid}".`);
    }
}
